import {ARRIVAL_BOT_TEXTS} from './constants';

export const onCloseArrivalBotTooltip = (phaseOfStay) => {
    localStorage.setItem(`abHelp_${phaseOfStay}`, 'true');
};

export const getArrivalBotHelpText = (phaseOfStay) => {
    return localStorage.getItem(`abHelp_${phaseOfStay}`) !== 'true'
        ? ARRIVAL_BOT_TEXTS[phaseOfStay]
        : '';
};
